import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';

@Component({
  selector: 'app-compra-view',
  templateUrl: './compra-view.component.html',
  styleUrls: ['./compra-view.component.scss']
})
export class CompraViewComponent implements OnInit {
  @Input() element: any = {}
  compra: FormGroup = new FormGroup({});
  total: number = 0;
  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService

  ) { }

  ngOnInit(): void {
    this.compra = this.formBuilder.group({
      id: [],
      fecha: [],
      detalles: [],
      monto: [],
      iva: [0],
      estado: [],
    });

    this.element.fecha = this.element.fecha.substring(0, 10);
    this.compra.patchValue(this.element);
    this.compra.disable()
    this.element.lineas.forEach((element: any) => {
      this.total += element.precio_linea;
    });
  }
}
